<template>
  <v-row class="desposite-dashboadpage">
    <v-col xs="8" md="8">
      <ul class="breadcrumbs-list">
        <a @click="backButton">
          <li>Investment</li>
        </a>
        <li>&nbsp;>&nbsp;Commodities Dashboard</li>
      </ul>
      <div class="head-text">
        <h1>Commodities Dashboard</h1>
      </div>
      <CommoditiesList/>
      
    </v-col>
    <v-col xs="4" md="4">
      <div class="right-sidetop-box">
        <div class="select-box">
          <v-card>
            <v-select :items="member_list" :v-model="member_name" item-value="id" item-text="name" chips label="All Users" @change="refershCommodityDashboard"></v-select>
          </v-card>
        </div>
        <div class="add-btn" v-if="allow_user_activity =='yes'">
          <v-btn class="orange-btn btn" @click="subCategory">ADD NEW</v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="right-sidebox">
            <div v-if="show_graph_block">
              <v-skeleton-loader :loading="loading" type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions">
                <div cols="12" class="total-deposit-box"> <span>
                Total Commodities Valuation on {{currentDate | moment("DD MMM, Y")}}
              </span> 
                  <p> <span>  &#8377;</span>
                    {{graphTotal.toLocaleString()}}</p>
                </div>
                <div id="chart">
                  <!-- <apexchart type="donut" :options="chartOptions" :series="series"></apexchart> -->
                  <apexchart type="pie" :options="chartOptions" :series="series"></apexchart>
                  <ul class="chart-listbox">
                    <li class="first-li" v-for="balance_detail in mutual_fund_balance_list" :key="balance_detail.id">
                      <div class="chart-listbox-dotbox"> <span class="dots" :style="{'background-color': balance_detail.web_color}"></span>
                        <p>{{balance_detail.commodity_name}}</p>
                      </div> <span> <span class="rupee"> &#8377;</span> {{balance_detail.balance}}</span>
                    </li>
                  </ul>
                </div>
                <div class="button-box">
                  <v-btn class="btn download-btn" @click="downloadReport">
                    <v-img max-height="20" max-width="16" :src="require('@/assets/images/download-icon.png')"></v-img>DOWNLOAD</v-btn>
                  <!-- <v-btn class="btn share-btn">
                    <v-img max-height="20" max-width="18" :src="require('@/assets/images/share-icon.png')"></v-img>SHARE</v-btn> -->
                    <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="btn share-btn" v-bind="attrs" v-on="on">
                     <v-img
                        max-height="20"
                        max-width="18"
                        :src="require('@/assets/images/share-icon.png')"
                      >
                    </v-img>
                    SHARE
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <WhatsApp :url="share_report_url" scale="1.6"></WhatsApp>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Telegram :url="share_report_url" scale="1.6"></Telegram>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Email :url="share_report_url" scale="1.6"></Email>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
                </div>
              </v-skeleton-loader>
            </div>
             <div v-else="!show_graph_block" style="margin-bottom:12px;">
              <v-list-item>
              <div class="user-detailbox">
                  <v-list-item-content>
                  <div class="text-h5 mb-1">
                    No data found in graph.
                  </div>
                </v-list-item-content>
              </div>
            </v-list-item>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  <div class="text-center ">
    <v-dialog
      v-model="dialog"
      width="500">
      <v-card class="secure-modal proceed-modal">
        <v-card-title class="">
          <h5>Select your option to proceed</h5>
           <v-card-actions class="close-icon">
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              <v-img max-height="23" max-width="19" :src="cancel_pic" :lazy-src="cancel_pic"> </v-img>
            </v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
         <div style="margin-top:10px;">
            <p>Select an option to upload your financial information</p>
            <div class="button-box">
              <v-btn
                class="orange-btn"
                @click="manuallyBtn(manuallyId)"
              >
                Add Manually <br> (Assisted Mode)
              </v-btn>
              <v-btn
                class="orange-btn"
                @click="uploadCSVBtn(manuallyId)"
              >
                Upload data <br> using CSV file
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

  <div class="text-center ">
    <v-dialog
      v-model="dialog1"
      width="550">
      <v-card class="secure-modal proceed-modal csv-file-modal">
        <v-card-title class="text-h5  ">
          <h5>Upload Using CSV File in 3 Steps</h5>
           <v-card-actions class="close-icon">
            <v-btn
              color="primary"
              text
              @click="dialog1 = false"
            >
              <v-img max-height="23" max-width="19" :src="cancel_pic" :lazy-src="cancel_pic"> </v-img>
            </v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
         <div style="margin-top:10px;">
          <span>Steps to follow</span>
          <ul>
            <li>Download CSV file on your laptop/desktop</li>
            <li>Fill in investment details</li>
            <li>Upload CSV file</li>
          </ul>
          <p style="color:#31465f ; text-align:center;">
            <b style="font-size:20px;">Note:-</b> 
          </p>
          <p style="color:#31465f ;">1- The dashboard will be updated basis the investment details provided in uploaded CSV file.</p>
          <p style="color:#31465f ;">2- The CSV file has the following fields and please note the instructions while entering the data.</p>
          <p style="color:#31465f ;">
            <ul>
              <li>“Exchange” – Enter exchange as “NSE” or “BSE” - example “NSE”.</li>
              <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
              <li>“Commodity Name” - Enter name of share as - example “Bajra”.</li>
              <li>“Location” – Enter location as – example “Jaipur”.</li>
              <li>“Number of Units” - Enter total number of units as on date.</li>
              <li>“Nominee” – Enter name of your nominee/s.</li>
            </ul>
          </p>
           <p style="color:#31465f ;">3- Please don’t add any additional field.</p>
          <p style="color:#31465f ;">4- Please don’t change header.</p>
          <p style="color:#31465f ;">5- View sample CSV file if you need any clarification.</p>
          <p style="color:#31465f ;">6- Once you upload a CSV file a table will be generated with all date provided.</p>
          <p style="color:#31465f ;">7- Please validate data which are marked as red in the table and confirm.</p>
          <p style="color:#31465f ;">8- Once confirmed you can view the dashboard.</p>
          <p style="color:#31465f ;">9- Your commodities valuation will be updated daily.</p>
          <p style="color:#31465f ;">10- You can subsequently modify number of units using “Edit” option from your dashboard.</p>
    <div class="button-box">
             <v-btn
              class="orange-btn"
              @click="viewBtn(manuallyId)"
            >
              <p>View</p>
              <p>Sample CSV file</p>
            </v-btn>
            <v-btn
              class="orange-btn"
              @click="downloadCSVBtn(manuallyId)"
            >
                <p>Download</p>
               <p>CSV file</p>
            </v-btn>
            <v-btn
              class="orange-btn"
              @click="uploadCSVFileBtn"
            >
              <p>Upload</p>
              <p>CSV file</p>
            </v-btn>
            </div>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="csv_dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload Doc</span>
        </v-card-title>
        <form
          ref="form"
          id="upload_deposit_keep_safe_form"
          @submit.prevent
          lazy-validation
        >
          <v-card-text >
            <v-container>
              <v-row >
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                <v-file-input
                  name="file"
                  id="fileUpload"
                  ref="file"
                  @change="handleFileUpload( $event )"
                  label="Choose Doc"
                  accept=".csv"
                ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn
              class="blue-border-btn"
              text
              @click="closeCsvDialog"  
            >
              Close
            </v-btn>
            <v-btn
              style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;"
              text
              @click="submit"  
            >
              Upload
            </v-btn>
          </v-card-actions>
        </form>  
      </v-card>
    </v-dialog> 
    <v-dialog v-model="preview_dialog" persistent max-width="1100px">
      <v-card-title class="equity-modal-imgbox">
        <v-card-actions class="close-icon">
            <v-btn
              color="primary"
              text
              @click="preview_dialog = false"
            >
              <v-img max-height="28" max-width="28" :src="cancel_pic" :lazy-src="cancel_pic"> </v-img>
            </v-btn>
        </v-card-actions>
        <v-col class="image-box">
          <v-img
            :src="previewImage"
            :lazy-src="previewImage"
          >
          </v-img>
      </v-col>
      </v-card-title>
    </v-dialog>
  </div>
  <!---------------Commodities child component------------------------------------------------------>
    <uploaded_commodity_data_list_component 
    v-bind:modal_commodity_open_status="is_commodity_modal_open" 
    v-bind:get_uploaded_commodity_list="uploaded_commodity_list"
    @getCommodityEditFormData="setCommodityEditFormData($event)"
    @getCommodityDashboardFormData="setCommodityDashboardFormData($event)"
    />

    <commodity_edit_form_component 
    v-bind:get_uploaded_commodity_detail_master_data_list="uploaded_commodity_detail_master_data_list" 
    v-bind:get_uploaded_commodity_master_data_list="uploaded_commodity_master_data_list" 
    v-if="is_commodity_edit_modal_open" 
    v-bind:commodity_edit_form_dialog_status="is_commodity_edit_modal_open" 
    v-bind:get_commodity_edit_form_data="commodity_edit_form_data"  
    @getCommodityUpdatedFormData="setCommodityUpdatedFormData($event)" />
  <!---------------End of Commodities child component------------------------------------------------>
  </v-row>



</template>
<script>
  import uploaded_commodity_data_list_component from '../segments/uploaded_commodity_list';
  import commodity_edit_form_component from '../segments/uploaded_commodity_edit_form';
  import { isEmpty,isNull, isUndefined } from 'lodash';
  import axios from "axios";
  import {  GET_COMMODITY_FORM_DETAIL, UPDATE_USER_DETAILS, GET_SUB_CATEGORY_DATA, GET_SECURITY_LIST } from "../../../store/actions.type";
  import ApiService from "../../../api/api.service";
  import { WhatsApp, Telegram, Email } from 'vue-socialmedia-share';
   import CommoditiesList from './CommoditiesList.vue';
   import JwtService from "../.././common/jwt.service";
    export default {
      components: {
    commodity_edit_form_component,
    uploaded_commodity_data_list_component,
    WhatsApp,
    Telegram,
    Email,
    CommoditiesList
},
      data: () => ({
        previewImage:'',
        listingData:[],
        category:'',
        dialog:false,
        dialog1:false,
        csv_dialog:false,
        preview_dialog:false,
       
        manuallyId:0,
        file: '',
        editedItem:[],
        edit_dialog:false,
        // exchange_items:[{id:'bse', name:'BSE'}, {id:'nse', name:'NSE'}],
        show_exchange_dropdown:false,
        show_exchange_text_field:true,
        exchange_field_type:'exchange_text_field',
        security_list:[],
        exchange:'',
        security_name:'',
        exchange_id:'',
        security_name_warning_msg:'',
        security_name_warning_msg_status:false,
        selected_exchange:'',
        selected_security_name:'',
        owner_warning_msg:'',
        selected_owner_name:'',
        owner_warning_msg_status:false,
        member_list:[],
        is_modal_open:false,
        uploaded_commodity_list:[],
        commodity_edit_form_data:{},
        is_commodity_edit_modal_open:false,
        commodity_row_index:'',
        member_items: [],
        member_name:'',
        three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
        edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
        cancel_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
        currentDate: new Date().setDate(new Date().getDate()),
        series: [],
        chartOptions: {
           dataLabels: {
            formatter(val) {
              return [ val.toFixed() + '%']
            }
          },
          labels: [],
          fill: {
            colors: []
          } ,
          chart: {
            type: 'pie',
            edrawOnParentResize: true,
          },
          responsive: [{
            breakpoint: undefined,
            options: {
            }
          }],
          legend: {
               show: false,
          } 
        },
        mutual_fund_balance_list:'',
        saving_balance:'',
        reccuring_balance:'',
        deposite_balance:'',
        sukanaya_balance:'',
        tabName:'',
        graphTotal:'',
        seriesTotal:[],
        member_list: [],
        show_graph_block:true,
        graphDefault:'',
        member_id:'',
        loading: false,
        graphDefault:'default',
        share_report_url:'',

        is_commodity_modal_open:false,
        uploaded_commodity_list:[],
        commodity_edit_form_data:'',
        commodity_row_index:'',
        is_commodity_edit_modal_open:false,
        uploaded_commodity_master_data_list:[],
        uploaded_commodity_detail_master_data_list:[],
        is_commodity_instruction:false,
        allow_user_activity:localStorage.getItem('allow_user_activity')
      }),
      created(){
        this.refershCommodityDashboard('');
      },
      mounted (){
          this.refershCommodityDashboard('');
          Fire.$on("commidities", () => {
           this.graphData('default');
          });
          // if(!isEmpty(this.$store.getters.getCommodityFormDetail)) {
          //   this.graphData('default');
          // }

         // Fire.$on("commiditiesDelete", () => {
         //   this.graphData('default');
         //  });
  
         // this.graphData(this.graphDefault);
         // if (this.graphDefault != 'default') {
         //  this.refershCommodityDashboard();
         // } 
        },
      methods:{
        setCommodityDashboardFormData(data){
          this.is_commodity_modal_open =false
          this.is_commodity_edit_modal_open =false
          this.is_modal_open =false
          this.dialog1 =false
          this.csv_dialog = false
          this.refershCommodityDashboard('');
        },
        setCommodityEditFormData(data){
          this.commodity_edit_form_data       = data
          this.commodity_row_index            = data.row_index 
          this.is_commodity_edit_modal_open   = data.is_edit_modal_open
        },

        setCommodityUpdatedFormData(form_array_object){
          if(form_array_object) {
            this.$set(this.uploaded_commodity_list, this.commodity_row_index, form_array_object)
          }          
          this.is_commodity_edit_modal_open = false
        },

        previewDialogClose(){
          this.preview_dialog = false;
        },

        csvDialogClose(){
          this.csv_dialog = false;
        },

        setCommodityEditFormData(data){          
          this.is_commodity_edit_modal_open = true
          this.commodity_edit_form_data     = data.row_item_detail
          this.commodity_row_index          = data.row_index 
        },

        setCommodityUpdatedFormData(form_array_object){
          if(form_array_object) {
            this.$set(this.uploaded_commodity_list, this.commodity_row_index, form_array_object)
          }          
          this.is_commodity_edit_modal_open = false
        },
        
        viewBtn(id){
          window.open('https://dev-api.nimeya.ai/csv_samples/commodities.csv','_blank');
          
        },
        downloadCSVBtn(id){
          window.open('https://dev-api.nimeya.ai/csv_samples/scommodities.csv','_blank');
        },
        manuallyBtn(id){
          this.$router.push({ name: "add-commodities",params: { form_id:id}}).catch(()=>{});
        },
        closeCsvDialog(){
          this.is_modal_open = false;
          if(document.getElementById("fileUpload").files.length >0){
            this.$refs.file.value=null;
          }
          this.csv_dialog = false;
          this.is_commodity_modal_open = false;
          this.is_commodity_edit_modal_open = false;
        },
        uploadCSVFileBtn(id){
          this.csv_dialog = true
        },
        uploadCSVBtn(id){
          this.dialog = false;
          this.dialog1 = true;
        },
        syncAccountBtn(){},
        uploadAccountBtn(){},
        handleFileUpload(){
          this.file = document.getElementById("fileUpload").files[0]
        },
        editItem(item, index){
          this.editedItem   = item;
          this.edit_dialog  = true;
          this.setMasterData()
        },
        close(){
          this.edit_dialog  = false;
        },
        save(){
          this.listingData.push(this.editedItem)
        },
        submit(e){
          if (this.file == '') {
          swal.fire({
            title: 'Missing File',
            text: "Please select a file.",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          });
          return;
        }
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let formdata  = new FormData();
          formdata.append("aws_cognito_id", cognito_idp);
          formdata.append("doc_file", this.file);
          formdata.append("form_type", 'commodity');
          formdata.append("name", this.$store.getters.getUserDetails.user_name);
          axios.post( process.env.VUE_APP_ROOT_API+'process-commodity-csv',
              formdata,{
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            ).then((response) => {
              if(response.data.status == 'error'){
                swal.fire({
                  title: response.data.message,
                  icon: 'error',
                  confirmButtonText: `Ok`
                })
              }
              else{
                this.is_commodity_modal_open = true
                this.uploaded_commodity_list   = response.data.data.list[0];
                this.uploaded_commodity_master_data_list=response.data.commodities;
                this.uploaded_commodity_detail_master_data_list=response.data.commodity_details;
              }
              }).catch(() => {
                this.$loading(false);
            });
        },
        showExchange(type){
          if(type ==  'show_dropdown'){
            this.show_exchange_text_field = false
            this.show_exchange_dropdown   = true
            this.exchange_field_type      = 'exchange_dropdown_field'
          }
          else{
            this.show_exchange_text_field = true
            this.show_exchange_dropdown   = false
            this.exchange_field_type      = 'exchange_text_field'
          }
        },
        subCategory(){
          this.manuallyId = 8;
          this.dialog = true;
        },
        backButton(){
          this.$router.push({ name: 'Investment'}).catch(()=>{});
        },
        graphData(type){
          this.colors = [];
          this.labels = [];
          this.series = this.series.length == 0 ? this.series : [];
          this.mutual_fund_balance_list  = [];
          this.seriesTotal = [];
          this.graphTotal = 0;
          this.member_list=this.$store.getters.getCommodityFormDetail.member_list;

          this.$store.getters.getCommodityFormDetail.balance_array.balance.forEach(garpColorData => {
            this.series.push(parseInt(garpColorData.balance));
            this.seriesTotal.push(garpColorData.balance);
            this.chartOptions.labels.push(garpColorData.commodity_name);
            this.chartOptions.fill.colors.push(garpColorData.web_color);
          

            this.mutual_fund_balance_list = this.$store.getters.getCommodityFormDetail.balance_array.balance;
            this.graphTotal = this.seriesTotal.reduce((a, b) => a + b, 0);
            
          })
           if (this.seriesTotal == 0 ) {
              this.show_graph_block = false;
            }else{
              this.show_graph_block = true;
            }
        },
        refershCommodityDashboard(event){
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name =  this.$store.getters.getUserDetails.user_name;
          let userData = [
            {key:'selected_value', value:event.toString()},
          ]
          this.$store.dispatch(UPDATE_USER_DETAILS,userData)

          // this.singleUpdateAuthUser('commitSingleData', {key:'selected_value', value:event.toString()});
          let selected_value = this.$store.getters.getUserDetails.selected_value;
          selected_value = selected_value ? selected_value : '';
          this.$store.dispatch(GET_COMMODITY_FORM_DETAIL, {
            data: {
              aws_cognito_id:cognito_idp,
              member_id:event,
              user_name:user_name
            },
            api: 'get-commodity-form-detail',
            }).then((res) => {
              console.log(this.$store.getters.getCommodityFormDetail)
              Fire.$emit('commidities');
              this.$loading(false);
                
            }).catch(() => {
               this.$loading(false) 
            })
          },
          downloadReport(){
            window.open(this.$store.getters.getCommodityFormDetail.pdf_url, '_blank');
          },
          shareLink(){
            this.share_report_url = this.$store.getters.getCommodityFormDetail.pdf_url;
            return this.share_report_url;
          },
      }
    }
</script>